<template>
  <!-- 這邊注意要有 direction="vertical"，因為el-header非第一層子元素 -->
  <el-container direction="vertical" :class="classes">
    <tg-header
      ref="header"
      :agent="agent"
      :member="member"
      :user="user"
      :floating="true"
      :type="type"
      @on-bars-click="handleBarsClick"
      @on-logout="handleLogout"
    >
      <slot name="title">{{ currentTitle }}</slot>
      <template v-slot:tools>
        <portal-target
          name="tools"
          multiple
          class="el-row is-justify-center is-align-middle el-row--flex"
        ></portal-target>
      </template>
      <template v-slot:extension>
        <portal-target name="extension"></portal-target>
      </template>
    </tg-header>
    <el-main class="tg-app--container is-mobile">
      <slot></slot>
    </el-main>
  </el-container>
</template>

<script>
import TgHeader from "@/components/header/TgHeader";

import { mapState } from "vuex";
import formatter from "@/utils/formatter";
export default {
  components: {
    TgHeader,
  },
  computed: {
    classes() {
      return [
        "tg-app",
        "is-mobile",
        "is-floating",
        {
          "has-extension": !!this.$scopedSlots.extension,
        },
      ];
    },
    containerClass() {
      return ["tg-app--container"];
    },
    currentTitle() {
      let meta = this.$route.meta;

      if (meta.title) {
        return meta.title;
      }

      if (meta && meta.parent && meta.parent.title) {
        return meta.parent.title;
      }

      return "";
    },
    ...mapState("app", {
      marquee: (state) => state.marquee,
      agent: (state) => formatter.thousand(state.onlineAgent),
      member: (state) => formatter.thousand(state.onlineMember),
      user: (state) => state.user,
    }),
    type() {
      return this.$route.meta.barsType ? this.$route.meta.barsType : "main";
    },
    floating() {
      return this.$route.meta && this.$route.meta.floating && this.isMobile;
    },
  },
  methods: {
    handleBarsClick() {
      this.$store.commit("app/TOGGLE_MENU_DRAWER");
    },
    parseContainerHeight() {
      // let height = window.innerHeight - this.$refs.container.$el.offsetTop;
      // this.$refs.container.$el.style.height = height + "px";
    },
    handleLogout() {
      this.$router.push({ name: "login" });
    },
  },
  mounted() {
    this.parseContainerHeight();
    window.addEventListener("resize", () => {
      this.parseContainerHeight();
    });
  },
};
</script>
